import React, { useState } from 'react';
import axios from 'axios';
import translations from "../../../utils/language/translations.json";
import { useTranslation } from "react-i18next";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
export const Register = ({setActiveView}) => {
  const { t: translate, i18n } = useTranslation(); // Correctly destructure `t` and `i18n`
  const currentLang = i18n.language; // Access the current language
  const t = (key) => translations.Register[key][currentLang];
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
 const [showPassword, setShowPassword] = useState(false);
  const validateEmail = (email) => {
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(String(email).toLowerCase());
  };
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!validateEmail(email)) {
      setMessage(t('invalidEmailError'));
      return;
    }

    if (password !== confirmPassword) {
      setMessage(t('passwordMismatchError'));
      return;
    }

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE}/api/Insertusers`, {
        email,
        username,
        password,
        confirmPassword
      },{ withCredentials: true });
      setMessage(response.data.message);
      setActiveView('login')
    } catch (error) {
      setMessage(t('registerError'));
      if (error.response && error.response.data && error.response.data.message) {
        setMessage(error.response.data.message);
      }
      console.error(error);
    }
  };




  const togglePasswordVisibility = () => setShowPassword(!showPassword);



  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px', marginTop: '15px' }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%' }}>
        <form onSubmit={handleSubmit}>
          <div >
            <label htmlFor="email" style={{ marginBottom: '5px' }}>{t('emailLabel')}</label>
            <input
              type="text"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t('emailPlaceholder')}
              required
              className='login-input'
            />
          </div>
          <div>
            <label htmlFor="username" style={{ marginBottom: '5px' }}>{t('usernameLabel')}</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder={t('usernamePlaceholder')}
              required
              className='login-input'
            />
          </div>
          <div>
            <label htmlFor="password" style={{ marginBottom: '5px' }}>{t('passwordLabel')}</label>
            <input
              type={showPassword ? 'text' : 'password'}
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={t('passwordPlaceholder')}
              required
              className='login-input'
            />
       
          </div>
          <div style={{width: '100%'}}>
          <label htmlFor="confirmPassword" style={{ marginBottom: '5px' }}>{t('confirmPasswordLabel')}</label>
            <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
              
            <input
               type={showPassword ? 'text' : 'password'}
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder={t('confirmPasswordPlaceholder')}
              required
             
              className='login-input'
            />
              <button
                              type="button"
                              onClick={togglePasswordVisibility}
                              style={{
                                background: 'white',
                                color: 'black',
                                border: 'none',
                                cursor: 'pointer',
                                fontSize: '1.2rem',
                                marginLeft: '-50px',
                                alignSelf:'center',
                                width:'3rem',
                                zIndex: 99,
                                padding:'0'
                              }}
                            >
                              {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </button>
                            </div>
          </div>
          <p><a href="/terms">{t('termsMessage')}</a></p>
          <button type="submit" className="btn-base"  style={{
                width: '100%',
                maxWidth: '300px',
                padding: '10px',
                borderRadius: '4px',
                cursor: 'pointer',
                marginTop: '20px',
                fontSize: '1rem'
              }}>
            {t('registerButton')}
            <svg width="17" height="10" viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.3333 10C11.3333 9.47 11.8525 8.67857 12.3781 8.01429C13.0539 7.15714 13.8614 6.40929 14.7872 5.83857C15.4813 5.41071 16.3228 5 17 5M17 5C16.3228 5 15.4806 4.58928 14.7872 4.16143C13.8614 3.59 13.0539 2.84214 12.3781 1.98643C11.8525 1.32143 11.3333 0.52857 11.3333 -1.41195e-06M17 5L-4.37114e-07 5" stroke="white" strokeWidth="2" />
            </svg>
          </button>
        </form>
        {message && <p>{message}</p>}
      </div>
    </div>
  );
};

export default Register;